import { render, staticRenderFns } from "./LoadingSign.vue?vue&type=template&id=3944612c&scoped=true&functional=true&"
import script from "./LoadingSign.vue?vue&type=script&lang=js&"
export * from "./LoadingSign.vue?vue&type=script&lang=js&"
import style0 from "./LoadingSign.vue?vue&type=style&index=0&id=3944612c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "3944612c",
  null
  
)

export default component.exports